export function thumbExtensionCreator(url, suffix) {
  const placeholder = 'https://via.placeholder.com/150.jpg?text=Orluna';

  if(!url || url.toString() === 'false'){ url = placeholder; } 

  const indexOfDot = url.lastIndexOf('.');

  return [url.slice(0, indexOfDot), suffix, url.slice(indexOfDot)].join('');
}
